module.exports = require("wix-location");